<template>
  <div>
    <v-btn @click="downloadExcel('blitz')">Download BlitzList</v-btn>
    <v-btn @click="openModal('addNewCompany')">Add Company</v-btn>
    <e-update-stats-modal
      :isOn="dialogs.delete"
      actionName="delete"
      @closeModal="closeModal('delete')"
      @submitAction="changeStatus('delete', changableId)"
      :disabled="buttonDisabled"
    />
    <e-update-stats-modal
      :isOn="dialogs.approve"
      actionName="approve"
      @closeModal="closeModal('approve')"
      @submitAction="changeStatus('approve', changableId)"
      :disabled="buttonDisabled"
    />
      <v-flex xs7>
        <v-layout>
          <v-flex xs2 class="mx-4">
            <v-select
              :items="categoriesList"
              item-text="name"
              item-value="id"
              v-model="activeCategory"
              label="Category Filter"
            />
          </v-flex>
          <v-flex xs2 class="mx-4">
            <v-select
              :items="statusOfCompany.statuses"
              v-model="activeStatus"
              label="Status Filter"
            />
          </v-flex>
          <v-flex xs2 class="mx-4">
            <v-select
              :items="visibilityStatusOfCompany.statuses"
              v-model="visibilityStatus"
              label="Visibility Status"
            />
          </v-flex>
          <v-flex xs3 class="mx-4">
            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="searchValue"
            />
          </v-flex>
          <v-flex xs1>
            <v-btn color="primary" @click.stop="reset">Reset</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs5 class="my-3 ml-5">
        <v-layout>
          Not Yet: {{getBlitzesCount.notYet}}
          <v-spacer/>
          Pending: {{getBlitzesCount.pending}}
          <v-spacer/>
          Approved: {{getBlitzesCount.approved}}
          <v-spacer/>
          Deleted: {{getBlitzesCount.deleted}}
        </v-layout>
      </v-flex>
    <v-data-table
      v-if="loadTable"
      item-key="id"
      :headers="headers"
      :items="getBlitzes"
      class="elevation-1"
      :pagination.sync="pagination"
      :total-items="getTotalItems"
      :loading="loading"
      :disable-initial-sort="true"
    >
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <tr :class="{ 'green': props.item.blitzInvitation.isSponsor }">
          <td class="text-xs">
            <v-flex
              align-center
              @click="openModal('showCompany', null, props.item)"
            >
              <span style="cursor:pointer">
                {{ checkCompanyName(props.item, 'No name') }}
              </span>
            </v-flex>
          </td>
          <td class="text-xs">
           {{receiveCategoryName(props.item.metadata.category)}}
          </td>
          <td class="text-xs">{{ props.item.blitzInvitation.status }}</td>
          <td class="text-xs">
            <v-flex text-xs-center>
              <div v-if="props.item.blitzCard">
                <v-switch
                  v-if="props.item.blitzInvitation.status !== 'Deleted'"
                  v-model="props.item.blitzCard.status"
                  true-value="Enabled"
                  false-value="Disabled"
                  :disabled="!isWriteAvailable"
                  @change="onChangeEnableStatus({companyId: props.item.id , newStatus: props.item.blitzCard.status})"
                />
              </div>
            </v-flex>

          </td>
          <td>
            <v-flex text-xs-center>
              <v-tooltip
                v-if="contains(props.item.blitzInvitation.status, statusOfCompany.resendBtn)"
                bottom
              >
                <v-btn
                  fab flat
                  color="info"
                  slot="activator"
                  @click="showReminderModal(props.item.id)"
                  :disabled="!isWriteAvailable"
                >
                  <v-icon>email</v-icon>
                </v-btn>
                <span>Remind invitation link</span>
              </v-tooltip>
            </v-flex>
          </td>
          <td>
            <v-flex text-xs-center>
              <v-tooltip
                v-if="contains(props.item.blitzInvitation.status, statusOfCompany.approveBtn)"
                bottom
              >
                <v-btn
                  color="success"

                  fab flat
                  slot="activator"
                  @click="openModal('approve', props.item.id)"
                >
                  <v-icon>done</v-icon>
                </v-btn>
                <span>Approve</span>
              </v-tooltip>
            </v-flex>
          </td>
          <td>
            <v-flex text-xs-center>
              <v-tooltip
                v-if="contains(props.item.blitzInvitation.status, statusOfCompany.deleteBtn)"
                bottom
              >
                <v-btn
                  color="error"
                  :disabled="!isWriteAvailable"
                  fab flat
                  slot="activator"
                  @click="openModal('delete', props.item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Delete</span>
              </v-tooltip>
            </v-flex>
          </td>
          <td>
            <v-flex text-xs-center>
              <v-tooltip
                v-if="contains(props.item.blitzInvitation.status, statusOfCompany.editBtn)"
                bottom
              >
                <v-btn
                  color="lime"
                  :disabled="!isWriteAvailable"
                  fab flat
                  slot="activator"
                  @click="openModal('edit', null, props.item)"
                >
                  <v-icon>create</v-icon>
                </v-btn>
                <span>Edit</span>
              </v-tooltip>
            </v-flex>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>

    <v-dialog
      persistent
      v-model="dialogs.edit"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon @click.native="closeModal('edit')" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="editableCompany">
            {{ checkCompanyName(editableCompany) }} Blitz Registration
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="onSaveEditableForm">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div v-if="dialogs.edit">
            <form-interpretator
              v-if="getFormData && editableCompany"
              :formType="getFormData.type"
              :formId="getFormData.id"
              :formGroup="getFormData.group"
              :formFields="getFormData.fields"
              :formMetadata="getFormData.metadata"
              :editableItem="editableCompany"
              ref="formInterpretator"
              @submit="onSubmitForm"
            />
            <div class="participants">
              <h3 class="participants__title">Participants displaying</h3>
              <div
                v-for="(participant, index) in participants"
                :key="`${participant.name}-${index}`"
              >
                <div class="participants__unit">
                  <p>{{ participant.name }}: <span :style="participantStateStyle(participant)">{{ participantLabel(participant) }}</span></p>
                  <div>
                    <v-switch
                      v-model="participant.state"
                    ></v-switch>
                  </div>
                </div>
              </div>
            </div>
            <v-checkbox
              label="Is Sponsor"
              v-model="isSponsor"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isReminderModalVisible"
      max-width="500px"
      persistent
    >
      <v-card tile>
        <v-card-title>
          <span class="headline capitalized">Remind</span>
        </v-card-title>
        <v-card-text>
          <v-select
            :items="blitzInvitationEmailTemplates"
            item-value="templateKey"
            item-text="templateKey"
            label="Reminder template"
            v-model="reminderTemplate"
          >
          </v-select>
          <v-spacer />
          <v-btn
            color="info"
            @click="closeReminderModal"
          >
            Cancel
          </v-btn>
          <v-btn
            color="success"
            @click="changeStatus('remind', changableId)"
          >
            Remind
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogs.addNewCompany"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon @click.native="closeModal('addNewCompany')" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Blitz Registration
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="onSaveEditableForm">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <content-field
            label="Name"
            v-model="invitation.name"
            :error="$v.invitation.name"
            @blur="$v.invitation.name.$touch()"
          />
          <content-field
            label="Company"
            v-model="invitation.company"
            :error="$v.invitation.company"
            @blur="$v.invitation.company.$touch()"
          />
          <content-field
            label="Email"
            v-model="invitation.email"
            :error="$v.invitation.email"
            @blur="$v.invitation.email.$touch()"
          />
          {{invitation.email}}
          <div v-if="dialogs.addNewCompany">
            <form-interpretator
              v-if="getFormData"
              :formType="getFormData.type"
              :formId="getFormData.id"
              :formGroup="getFormData.group"
              :formFields="filterFormFields(getFormData.fields)"
              :formMetadata="getFormData.metadata"
              ref="formInterpretator"
              @submit="onCreateForm"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <modal-company-info
      v-if="!!editableCompany"
      :show="dialogs.showCompany"
      @close="closeModal('showCompany')"
      :editableCompany="editableCompany"
    />


  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import EUpdateStatsModal from './changeStatusModal'
  import ModalCompanyInfo from './modalCompanyInfo'
  import FormInterpretator from '@/components/shared/EvFormInterpretator'
  import { required, email } from 'vuelidate/lib/validators'
  import { statusOfCompany, categoryOfCompany, visibilityStatusOfCompany, sortWay } from '@/modules/settings/'
  import { pathOr, contains, equals, isNil } from 'ramda'
  import mixins from '@/utils/mixins'

  export default {
    name: 'BlitzList',
    mixins: [mixins.isWriteAvailable],
    components: {
      ModalCompanyInfo,
      EUpdateStatsModal,
      FormInterpretator
    },
    data () {
      return {
        participants: [
          {name: 'First participant', state: true},
          {name: 'Second participant', state: true},
          {name: 'Third participant', state: true}
        ],
        SaveEditableForm: false,
        statusOfCompany,
        categoryOfCompany,
        visibilityStatusOfCompany,
        sortWay,
        comparedParams: null,
        isReminderModalVisible: false,
        reminderTemplate: '',
        activeStatus: '',
        activeCategory: '',
        visibilityStatus: '',
        showOnlyApprove: null,
        searchValue: '',
        loading: true,
        loadTable: false,
        isSponsor: false,
        pagination: {
          page: 1,
          rowsPerPage: 10
        },
        dialogs: {
          edit: false,
          addNewCompany: false,
          delete: false,
          showCompany: false,
          remind: false,
          approve: false
        },
        editableCompany: null,
        headers: [
          { text: 'Company', align: 'left', value: 'company', search: true, sortable: true, width: 400 },
          { text: 'Category', value: 'category', search: true, sortable: true, width: 300 },
          { text: 'Status', value: 'status', search: true, sortable: true, width: 250 },
          { text: 'Disable/Enable', search: false, sortable: false, align: 'center', width: 100 },
          { text: 'Remind', search: false, sortable: false, align: 'center', width: 100 },
          { text: 'Approve', search: false, sortable: false, align: 'center', width: 100 },
          { text: 'Delete', search: false, sortable: false, align: 'center', width: 100 },
          { text: 'Edit', search: false, sortable: false, align: 'center', width: 100 }
        ],
        changableId: null,
        invitation: {
          name: '',
          email: '',
          company: '',
          status: 'NotYet'
        },
        paginationOptions: null,
        buttonDisabled: false,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'blitz:write'
      }
    },
    validations: {
      invitation: {
        name: { required },
        company: { required },
        email: { required, email }
      }
    },
    computed: {
      ...mapGetters([
        'getBlitzes',
        'getBlitzesCount',
        'getTotalPages',
        'getTotalItems',
        'getFormData',
        'getEmailTemplates',
        'getFormData',
        'categoriesList'
      ]),
      blitzInvitationEmailTemplates () {
        const emailTemplates = this.getEmailTemplates.filter(template => template.category === "BlitzInvitation")
        return emailTemplates
      }
    },
    watch: {
      searchValue (val) {
        if (!val) this.reset ()
        this.getDataFromApi()
      },
      pagination: {
        handler (val, oldVal) {
          if (val.totalItems !== oldVal.totalItems) return
          this.getDataFromApi()
        },
        deep: true
      },
      activeStatus (val) {
        if (val) this.getDataFromApi()
      },
      activeCategory (val) {
        if (val) this.getDataFromApi()
      },
      visibilityStatus (val) {
        if (val) this.getDataFromApi()
      }
    },
    methods: {
      contains,
      ...mapActions([
        'fetchBlitzSubmits',
        'fetchBlitzCounter',
        'updateBlitzSubmitStatus',
        'blitzRemindSubmit',
        'addBlitzCompany',
        'updateCompanies',
        'getInterpritationFormData',
        'downloadExcel',
        'getCategoriesList',
        'fetchEmailTemplates'
      ]),
      participantStateStyle ({state}) {
        return state ? {color: '#00b300'} : {color: '#ff0000'}
      },
      participantLabel({state}) {
        return state ? 'show' : 'hide'
      },
      showReminderModal(id) {
        this.changableId = id
        this.isReminderModalVisible = true
      },
      closeReminderModal() {
        this.isReminderModalVisible = false
        this.changableId = null
      },
      receiveCategoryName(categoryId) {
        if (!categoryId) return
        const currentCategory = this.categoriesList.find(category => category.id === categoryId)
        return !isNil(currentCategory) ? currentCategory.name : ''
      },
      sortingDirection (dir) {
        return dir ? 'Desc' : 'Asc'
      },
      sort (str) {
        if (str === 'blitzCard.status') {
          this.showOnlyApprove = true
          return 'BlitzCard.Status'
        }
        return this.sortWay[str]
      },
      async reset () {
        this.searchValue = ''
        this.activeStatus = ''
        this.activeCategory = ''
        this.visibilityStatus = ''
        this.pagination = {
          page: 1,
          rowsPerPage: 10,
          sortBy: null,
          descending: false
        }
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        this.loading = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const newPage = page - 1
        const pageCheck = newPage > 0 ? newPage : 0
        const sorted = !!sortBy ? this.sort(sortBy) : null
        const filter = {
          searchValue: this.searchValue,
          filterBy: this.sortWay['company']
        }
        const sorter = {
          direction: this.sortingDirection(descending),
          sortBy: sorted
        }
        const equalsStatus = {
          status: this.activeStatus,
          filterBy: this.sort('status')
        }
        const equalsCategory = {
          category: this.activeCategory,
          filterBy: this.sort('category')
        }
        const equalsVisibilityStatus = {
          visibilityStatus: this.visibilityStatus,
          filterBy: this.sort('visibilityStatus')
        }
        const getParams = {
          page: pageCheck,
          itemsOnPage: equals(rowsPerPage, -1) ? this.getTotalItems : rowsPerPage,
          filter,
          sorter,
          equalsStatus,
          equalsCategory,
          equalsVisibilityStatus
        }
        try {
          if (!equals(getParams, this.comparedParams) || this.SaveEditableForm) {
            await this.fetchBlitzSubmits(getParams)
            await this.fetchBlitzCounter()
          }
          this.showOnlyApprove = null
          this.loadTable = true
          this.comparedParams = getParams
        } catch (e) {
          this.SaveEditableForm = false
          console.log(e)
        } finally {
          this.SaveEditableForm = false
          this.loading = false
        }
      },
      async changeStatus (actionString, blitzId) {
        this.buttonDisabled = true
        try {
          if (actionString === 'remind') {
            await  this.blitzRemindSubmit({'blitzId': blitzId, 'emailTemplateKey': this.reminderTemplate})
          } else {
            await this.updateBlitzSubmitStatus({ actionString, blitzId })
          }
          await this.getDataFromApi()
        } catch (err) {
          this.showResultErrorMessage(err.message)
        } finally {
          this.closeModal(actionString)
          this.buttonDisabled = false
        }
      },
      onChangeEnableStatus ({ companyId, newStatus }) {
        this.updateCompanies([
          {
            id: companyId,
            status: newStatus
          }
        ])
      },
      onSaveEditableForm () {
        this.$v.invitation.$touch()
        if (this.$v.invitation.invalid) return
        this.$refs.formInterpretator.submitForm()
        this.SaveEditableForm = true
      },
      async onSubmitForm (form) {
        // set isParticipantShow field for all participants. This field responsible for displaying participants on web portal, 'networking-blitz' page.
        form.participants.forEach((el, i) => {
          el.isParticipantShow = pathOr(true, ['state'], this.participants[i])
        })
        await this.updateCompanies(
          [{
            id: this.editableCompany.id,
            body: form,
            isSponsor: this.isSponsor
          }]
        )
        await this.getDataFromApi()
      },
      async onCreateForm (form) {
        const card = {
          status: 'Disabled',
          order: 0
        }
        const metadata = {
          name: this.invitation.name,
          email: this.invitation.email,
          companyName: this.invitation.company,
        }
        const participantsCount = form.participants.length
        const invitation = { ...this.invitation, participantsCount }
        const payload = { card, body: { ...form, ...metadata }, invitation }
        await this.addBlitzCompany(payload)
        await this.getDataFromApi()
      },
      initParticipantsState (editableCompany) {
        const participants = pathOr([], ['metadata', 'participants'], editableCompany)
        this.participants.forEach((el, i) => {
          el.state = pathOr(true, ['isParticipantShow'], participants[i])
        })
      },
      openModal (actionString, id, editableCompany) { // pass one of keys from data's dialog property
        this.dialogs[actionString] = true
        switch (actionString) {
          case 'edit':
            this.editableCompany = editableCompany
            this.isSponsor = this.editableCompany.blitzInvitation.isSponsor
            this.initParticipantsState (editableCompany)
            break;
          case 'showCompany':
            this.editableCompany = editableCompany
            this.isSponsor = this.editableCompany.blitzInvitation.isSponsor
            break;
          case 'delete':
            this.changableId = id;
            break;
          case 'approve':
            this.changableId = id;
            break;
          default:
            break;
        }
      },
      closeModal (typeOfAction) {
        this.dialogs[typeOfAction] = false
      },
      checkCompanyName (editableCompany, defaultValue = '') {
        const blitzInvitationCompany = pathOr(defaultValue, ['blitzInvitation', 'company'], editableCompany)
        return pathOr(blitzInvitationCompany, ['metadata', 'companyName'], editableCompany)
      },
      filterFormFields (formFields) {
        return formFields.filter(val => {
          let property = val.layout.property
          switch (property) {
            case 'email':
              return false
            case 'companyName':
              return false
            case 'name':
              return false
            default:
              return true
          }
        })
      },
      async receiveRequiredData () {
        await this.getInterpritationFormData('blitz_registration')
        await this.getDataFromApi()
        await this.getCategoriesList({'itemsOnPage': 9999, 'page': 0})
        if(!this.getEmailTemplates.length) await this.fetchEmailTemplates()
      }
    },
    mounted () {
      this.receiveRequiredData()
    }
  }
</script>

<style lang="scss" scoped>
  .table-cell-center {
    display: flex;
    justify-content: center;
  }

  /deep/ .input-group__input {
    display: flex;
    justify-content: center;
  }

  .participants {
    display: flex;
    flex-direction: column;

    &__title {
      margin-bottom: 25px;
    }

    &__unit {
      display: flex;
      justify-content: space-between;
      max-width: 240px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/BlitzList/index.vue